import { z } from "zod";

import { AppointmentType } from "@/src/models/appointment";

export const schedulingAppointmentTypeOptionSchema = z.object({
  value: z.nativeEnum(AppointmentType),
  label: z.string().min(1),
});

export type SchedulingAppointmentTypeOption = z.infer<typeof schedulingAppointmentTypeOptionSchema>;

export const DEFAULT_SMS_INBOX_AVAILABILITY_APPOINTMENT_TYPES: SchedulingAppointmentTypeOption[] = [
  { value: AppointmentType.NEW_PATIENT_CHECKIN, label: "New Patient Checkin" },
  { value: AppointmentType.EXISTING_PATIENT_CHECKIN, label: "Existing Patient Checkin" },
];

export const schedulingCapabilitiesSchema = z.object({
  emrSchedulingSupported: z.boolean(),
  locationBasedScheduling: z.boolean(),
  smsInboxAvailabilityAppointmentTypes: z.array(schedulingAppointmentTypeOptionSchema).min(1),
});

export type SchedulingCapabilities = z.infer<typeof schedulingCapabilitiesSchema>;
